// extracted by mini-css-extract-plugin
export var bubble = "_w-0";
export var container = "_w-f";
export var contrastBorder = "_w-g";
export var greyOut = "_w-2";
export var initialsColor0 = "_w-3";
export var initialsColor1 = "_w-4";
export var initialsColor10 = "_w-d";
export var initialsColor11 = "_w-e";
export var initialsColor2 = "_w-5";
export var initialsColor3 = "_w-6";
export var initialsColor4 = "_w-7";
export var initialsColor5 = "_w-8";
export var initialsColor6 = "_w-9";
export var initialsColor7 = "_w-a";
export var initialsColor8 = "_w-b";
export var initialsColor9 = "_w-c";
export var initialsWrapper = "_w-1";
export var large = "_w-l";
export var medium = "_w-k";
export var mediumSmall = "_w-j";
export var mediumSmallMedium = "_w-o";
export var micro = "_w-h";
export var small = "_w-i";
export var tiny = "_w-n";
export var xTiny = "_w-m";